import { z } from "zod";
import { WorkspaceRole } from "../../workspace";
import { SupernovaException } from "../../utils";

export const DesignSystemRole = z.enum([
  WorkspaceRole.Admin,
  WorkspaceRole.Contributor,
  WorkspaceRole.Creator,
  WorkspaceRole.Viewer,
]);
export type DesignSystemRole = z.infer<typeof DesignSystemRole>;

export function workspaceRoleToDesignSystemRole(role: WorkspaceRole): DesignSystemRole {
  switch (role) {
    case "Owner":
    case "Admin":
      return "Admin";
    case "Creator":
      return "Creator";
    case "Contributor":
      return "Contributor";
    case "Billing":
    case "Viewer":
      return "Viewer";
    case "Guest":
      throw SupernovaException.shouldNotHappen(`Illegal role ${role}`);
  }
}
